<template>
    <div class="comment__reply" :id="replayToId" @click="openInput">
        ответить
    </div>
</template>

<script>
    import {OPEN_INPUT_ACTION} from "VueApps/comments/actions/actions";
    import {getUniqueId} from "VueApps/comments/services/getIdForInput";

    export default {
        name: "ReplyBtn",
        props: {
            replayToId: {
                required: true,
                type: Number,
            }
        },
        methods: {
            openInput: function () {
                this.$store.dispatch(OPEN_INPUT_ACTION, {
                    answerToId: this.replayToId,
                });

                setTimeout(() => {
                    document
                        .getElementById(getUniqueId(this.replayToId))
                        .scrollIntoView({
                            block: "center",
                            behavior: "smooth"
                        });
                }, 100);
            }
        }
    }
</script>

<style scoped>

</style>
